"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var mobx_react_1 = require("mobx-react");

var core_1 = require("@material-ui/core");

var LockOpen_1 = require("@material-ui/icons/LockOpen");

var react_router_1 = require("react-router");

var PantLogin = function PantLogin(props) {
  var appState = props.appState;
  var sessState = appState.sessState;
  var pantState = appState.pantState;
  var notiState = appState.notiState;

  if (!!props.appState.config.urlNoLogin) {
    window.location.href = props.appState.config.urlNoLogin; // setTimeout(() => window.location.href = this.props.appState.config.urlNoLogin, 0);
  }

  var handleChangeUsuari = function handleChangeUsuari(event) {
    sessState.setUsuari(event.target.value);
  };

  var handleChangePassword = function handleChangePassword(event) {
    sessState.setPassword(event.target.value);
  };

  var handleLogin = function handleLogin() {
    sessState.login(sessState.loginInfo.user, sessState.loginInfo.password).then(function () {
      if (!sessState.esLoginat) {
        notiState.showMessage('Usuari o Contrassenya Incorrectes!', 'error');
      } else if (!tePermis()) {
        notiState.showMessage('No tens permís per accedir!', 'warning');
      }
    });
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    handleLogin();
  };

  var tePermis = function tePermis() {
    var permisMinim = (props.location.state || {
      permisMinim: -1
    }).permisMinim;
    return sessState.tePermis && sessState.permis >= permisMinim;
  };

  if (sessState.esLoginat && tePermis()) {
    var from = (props.location.state || {
      from: {
        pathname: '/'
      }
    }).from;
    return React.createElement(react_router_1.Redirect, {
      to: from
    });
  }

  if (!!props.appState.config.urlNoLogin) {
    return null;
  }

  var formLogin = React.createElement("form", {
    onSubmit: handleSubmit
  }, React.createElement(core_1.DialogTitle, null, "Login"), React.createElement(core_1.DialogContent, {
    style: {
      overflowY: 'hidden',
      marginBottom: 10
    }
  }, React.createElement(core_1.Grid, {
    container: true,
    spacing: 3
  }, React.createElement(core_1.Grid, {
    item: true,
    xs: 12
  }, React.createElement(core_1.TextField, {
    autoFocus: true,
    placeholder: "Usuari",
    label: "Usuari",
    fullWidth: true,
    value: sessState.loginInfo.user,
    onChange: handleChangeUsuari
  })), React.createElement(core_1.Grid, {
    item: true,
    xs: 12
  }, React.createElement(core_1.TextField, {
    placeholder: "Contrassenya",
    label: "Contrassenya",
    type: "password",
    fullWidth: true,
    value: sessState.loginInfo.password,
    onChange: handleChangePassword
  })))), React.createElement(core_1.DialogActions, null, React.createElement(core_1.Button, {
    type: "submit",
    color: "primary",
    variant: "contained"
  }, React.createElement(LockOpen_1.default, {
    style: {
      marginRight: 5
    }
  }), " Login")));
  return !!pantState.width && pantState.width < 500 ? React.createElement("div", {
    style: {
      marginTop: pantState.marginHead
    }
  }, formLogin) : React.createElement(core_1.Dialog, {
    open: true,
    className: "Login",
    // modal={true}
    maxWidth: "sm",
    fullWidth: true
  }, formLogin);
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(PantLogin));